export default "__VITE_ASSET__DMa08fjD__"